var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.875V9.375C15 9.87228 14.8025 10.3492 14.4508 10.7008C14.0992 11.0525 13.6223 11.25 13.125 11.25H8.4375L3.75 15V11.25H1.875C1.37772 11.25 0.900805 11.0525 0.549175 10.7008C0.197544 10.3492 0 9.87228 0 9.375V1.875C0 1.37772 0.197544 0.900805 0.549175 0.549175C0.900805 0.197544 1.37772 0 1.875 0H13.125C13.6223 0 14.0992 0.197544 14.4508 0.549175C14.8025 0.900805 15 1.37772 15 1.875ZM4.6875 4.6875H2.8125V6.5625H4.6875V4.6875ZM6.5625 4.6875H8.4375V6.5625H6.5625V4.6875ZM12.1875 4.6875H10.3125V6.5625H12.1875V4.6875Z",
    fill: "#9F9D9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.df110526ff514100b45ba5bdd447d834.svg";
export { ForwardRef as ReactComponent };